class PoRegisterform extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.email = this.querySelector('[name="customer[email]"]');
        this.password = this.querySelector('[name="customer[password]"]');
        this.confirmPassword = this.querySelector('#customerPasswordConfirm');
        this.firstName = this.querySelector('[name="customer[first_name]"]');
        this.lastName = this.querySelector('[name="customer[last_name]"]');
        this.birthday = this.querySelector('#birthday-input');
        this.input_acceptMarketing = this.querySelector('input[name="customer[accepts_marketing]"]');
        this.errorMessage = this.querySelector(".form__message.custom_error");
        this.submit = this.querySelector("#submit-button");
        this.errorSummary = this.querySelector('#error-summary');
    }

    connectedCallback() {
        if (this.submit) {
            this.submit.addEventListener("click", (e) => this.onSubmit(e));
        }

        if (this.formSubmitted()) {
            this.hideForm();
        }
    }

    formSubmitted() {
        const params = new URLSearchParams(window.location.search);
        return params.get("customer_posted") === "true";
    }

    hideForm() {
        this.content.style.display = "none";
    }


    hideMailError() {
        if (this.errorMessage) {
            this.errorMessage.style.display = "none";
        }
    }

    showMailError() {
        if (this.errorMessage) {
            this.errorMessage.style.display = "flex";
        }
    }

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    isValidPassword(password) {
        const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
        return passwordRegex.test(password);
    }

    getCurrentCountryCode() {
        const localeCountry = window.SHOP_LOCALES?.current?.iso_code?.split('-')?.[1];
        return localeCountry ? localeCountry.toUpperCase() : '';
    }

    getCurrentLocaleCode() {
        const locale = window.SHOP_LOCALES?.current?.iso_code?.split('-')?.[0];
        return locale ? locale.toLowerCase() : '';
    }

    getCountryNameFromCode(countryCode) {
        if (!countryCode) return '';

        try {
            if (typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function') {
                const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
                return displayNames.of(countryCode) || '';
            }
        } catch (error) {
            console.warn('[Register] Unable to resolve country name from code:', countryCode, error);
        }

        return '';
    }

    upsertHiddenInput(name, value) {
        if (!name || !value || !this.form) return;

        let input = this.form.querySelector(`input[name="${name}"]`);
        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            this.form.appendChild(input);
        }

        input.value = value;
    }

    syncLocaleInputs() {
        const countryCode = this.getCurrentCountryCode();
        const localeCode = this.getCurrentLocaleCode();

        this.upsertHiddenInput('country', countryCode);
        this.upsertHiddenInput('country_code', countryCode);
        this.upsertHiddenInput('locale_code', localeCode);
    }

    showErrorIcon(field) {
        const errorIcon = field.parentElement.querySelector('.error-icon');
        if (errorIcon) {
            errorIcon.style.display = 'block';
        }
    }

    validateField(field, validator, errorMessageElement) {
        const errorMessage = errorMessageElement.dataset.errorMessage;
        if (!validator(field.value.trim())) {
            errorMessageElement.textContent = errorMessage;
            field.classList.add('tw-error-border');
            field.closest('po-text-field').classList.add('tw-po-textfield-error');
            field.closest('po-text-field').querySelector('.tw-error-message').classList.add('po-error-text');
            field.closest('po-text-field').querySelector('.tw-error-message').classList.remove('tw-hidden');
            field.setAttribute("aria-invalid", "true");
        } else {
            errorMessageElement.textContent = '';
            field.classList.remove('tw-error-border');
            field.closest('po-text-field').classList.remove('tw-po-textfield-error');
            field.closest('po-text-field').querySelector('.tw-error-message').classList.remove('po-error-text');
            field.closest('po-text-field').querySelector('.tw-error-message').classList.add('tw-hidden');
            field.removeAttribute("aria-invalid");
        }
    }

    onSubmit(e) {
        e.preventDefault();
        this.hasSubmitted = true;
        let isValid = true;
        let errors = [];
        // this.querySelectorAll('.tw-error-message').forEach(el => {
        //     el.classList.add('po-error-text');
        //     el.classList.remove('tw-hidden');
        // });

        const fields = [
            { field: this.firstName, errorElement: this.querySelector('#first-name-error'), validator: val => val.length > 0 },
            { field: this.lastName, errorElement: this.querySelector('#last-name-error'), validator: val => val.length > 0 },
            { field: this.email, errorElement: this.querySelector('#email-error'), validator: val => this.isValidEmail(val) },
            { field: this.birthday, errorElement: this.querySelector('#birthday-error'), validator: val => true },
            { field: this.password, errorElement: this.querySelector('#password-error'), validator: val => this.isValidPassword(val) },
            { field: this.confirmPassword, errorElement: this.querySelector('#confirm-password-error'), validator: val => val === this.password.value.trim() }
        ];

        fields.forEach(({ field, errorElement, validator }) => {
            if (!validator(field.value.trim())) {
                isValid = false;
                errors.push(errorElement.dataset.errorMessage);
                this.validateField(field, validator, errorElement);
                if (!field.hasEventListener) {
                    field.addEventListener('input', () => {
                        if (this.hasSubmitted) {
                            this.validateField(field, validator, errorElement);
                        }
                    });
                    field.hasEventListener = true;
                }
            }
        });

        // Verifica anche la validazione dell'età
        const birthdayInput = document.querySelector('po-birthday-input');
        if (birthdayInput && typeof birthdayInput.validateAge === 'function') {
            const ageIsValid = birthdayInput.validateAge();
            if (!ageIsValid) {
                isValid = false;
            }
        }

        if (isValid && !this.submit.hasAttribute('disabled')) {
            this.syncLocaleInputs();

            const marketCountryCode = (
                this.form.querySelector('input[name="country_code"]')?.value ||
                this.form.querySelector('input[name="country"]')?.value ||
                this.getCurrentCountryCode() ||
                ''
            ).toUpperCase();
            const marketCountryName = this.getCountryNameFromCode(marketCountryCode);

            if (marketCountryCode) {
                sessionStorage.setItem('registrationCountryCode', marketCountryCode);
                localStorage.setItem('registrationCountryCode', marketCountryCode);
            }

            if (marketCountryName) {
                sessionStorage.setItem('registrationCountryName', marketCountryName);
                localStorage.setItem('registrationCountryName', marketCountryName);
            }

            // Imposta l'URL di reindirizzamento corretto tenendo conto del root_url
            const returnToInput = this.form.querySelector('input[name="return_to"]');
            if (returnToInput) {
                // Se SHOP_LOCALES è disponibile, ottieni il root_url appropriato
                if (window.SHOP_LOCALES && window.SHOP_LOCALES.current) {
                    const rootUrl = window.SHOP_LOCALES.current.root_url || '';
                    const accountPath = rootUrl + '/account';
                    
                    // Aggiorna l'URL di reindirizzamento
                    returnToInput.value = accountPath;
                    //console.log(`[Register] Reindirizzamento impostato a: ${accountPath}`);
                } else {
                    console.warn('[Register] SHOP_LOCALES non disponibile, usando percorso predefinito /account');
                }
            } else {
                console.warn('[Register] Input return_to non trovato nel form');
            }

            // Gestisci la checkbox di marketing in base alla regione
            const region = typeof detectRegionFromShopifyLocales === 'function' ? detectRegionFromShopifyLocales() : 'DEFAULT';
            
            // Ottieni lo stato della checkbox visibile nel form
            let marketingPreference = false;
            
            if (region === 'US') {
                // Per US è sempre true, secondo il requisito
                marketingPreference = true;
                //console.log('[Register] Regione US: impostazione marketing a true');
            } else {
                // Per altre regioni, controlla quale checkbox è visibile
                const defaultCheckbox = document.getElementById('check-example-readonly');
                const caCheckbox = document.getElementById('check-example-readonly-ca');
                const emeaCheckbox = document.getElementById('check-example-readonly-emea');
                
                // Cerca quale checkbox è visibile e prendi il suo valore
                if (defaultCheckbox && defaultCheckbox.closest('div').style.display !== 'none') {
                    marketingPreference = defaultCheckbox.checked;
                } else if (caCheckbox && caCheckbox.closest('div').style.display !== 'none') {
                    marketingPreference = caCheckbox.checked;
                } else if (emeaCheckbox && emeaCheckbox.closest('div').style.display !== 'none') {
                    marketingPreference = emeaCheckbox.checked;
                }
                
                //console.log(`[Register] Regione ${region}: preferenza marketing rilevata = ${marketingPreference}`);
            }
            
            // Salva la preferenza dell'utente per uso futuro
            localStorage.setItem('user_marketing_preference', marketingPreference);
            
            // Salva il flag per indicare che l'account è nuovo
            localStorage.setItem('is-account-new', 'true');
            
            // Salva anche l'info sulla regione attuale per uso futuro
            localStorage.setItem('user_region', region);
            
            // Salva le credenziali in c_profile per auto-login post-registrazione
            const dataObj = [{ 
                e: this.email.value.trim(), 
                p: this.password.value.trim() 
            }];
            const encodedString = btoa(JSON.stringify(dataObj));
            localStorage.setItem('c_profile', encodedString);
            
            // Sync birthday to hidden customer[tags] so Shopify persists it (create_customer does not support metafields).
            // Merge all customer[tags] inputs (static tags + birthday) into a single submission value
            // to avoid duplicate fields overwriting each other on the server.
            const dateValue = this.birthday?.value?.trim();
            const allTagsInputs = Array.from(this.form.querySelectorAll('input[name="customer[tags]"]'));
            if (allTagsInputs.length > 0) {
                const allTags = new Set();
                allTagsInputs.forEach(input => {
                    input.value.split(',').map(t => t.trim()).filter(Boolean).forEach(t => allTags.add(t));
                });
                // Replace any stale birth: entry with the current date value
                Array.from(allTags).filter(t => t.startsWith('birth:')).forEach(t => allTags.delete(t));
                if (dateValue) {
                    allTags.add('birth:' + dateValue);
                }
                allTagsInputs[0].value = Array.from(allTags).join(',');
                allTagsInputs.slice(1).forEach(input => (input.disabled = true));
            }
            
            // Invia il form
            // --- Ensure an explicit accepts_marketing value is submitted ---
            // Some browsers/flows can omit unchecked checkboxes from FormData; and
            // there are multiple inputs with the same name (checkbox variants per-region).
            // To avoid accidental subscriptions, create/update a hidden input with the
            // exact boolean value and disable the visible checkboxes so only the
            // explicit value is sent to Shopify.
            try {
                // Disable any checkbox inputs with the same name so they don't get sent
                const checkboxEls = Array.from(this.form.querySelectorAll('input[type="checkbox"][name="customer[accepts_marketing]"]'));
                checkboxEls.forEach(cb => cb.disabled = true);

                // Find or create a hidden input to carry the explicit value
                let explicitInput = this.form.querySelector('input[type="hidden"][name="customer[accepts_marketing]"]');
                if (!explicitInput) {
                    explicitInput = document.createElement('input');
                    explicitInput.type = 'hidden';
                    explicitInput.name = 'customer[accepts_marketing]';
                    this.form.appendChild(explicitInput);
                }
                explicitInput.value = marketingPreference ? 'true' : 'false';
            } catch (e) {
                // If anything goes wrong with DOM manipulation, still submit the form
                // swallow error silently in production
            }

            this.form.submit();
        }
    }
}

customElements.define("po-register-form", PoRegisterform);
